// The Online Policy create / edit form's look (2026-10-19): the same palette as the Edit dialogs (StageStatusDialog,
// KycFilesDialog) — navy titles, Inter, grey borders, navy main buttons. Styles only; no behaviour lives here.
export const NAVY = "#1E3A5F";
export const FONT = "Inter, Poppins, sans-serif";

/** A section title: navy, Inter, with a short navy bar before it. Spread it and add the spacing the spot had. */
export const SECTION_TITLE_SX = {
  fontFamily: FONT,
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "22px",
  color: NAVY,
  display: "flex",
  alignItems: "center",
  gap: "10px",
  "&::before": {
    content: '""',
    width: "4px",
    height: "18px",
    borderRadius: "4px",
    backgroundColor: NAVY,
    flexShrink: 0,
  },
};

/** A line between sections. */
export const SECTION_DIVIDER_SX = { backgroundColor: "#F2F4F7", borderWidth: 1 };

/** Buttons: the main action, the secondary one, and a destructive one. */
const BUTTON_BASE = {
  textTransform: "none",
  fontFamily: FONT,
  fontWeight: 600,
  fontSize: "14px",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": { boxShadow: "none" },
};
export const PRIMARY_BUTTON_SX = {
  ...BUTTON_BASE,
  backgroundColor: NAVY,
  color: "#fff",
  "&:hover": { backgroundColor: "#16304F", boxShadow: "none" },
  "&.Mui-disabled": { backgroundColor: "#E4E7EC", color: "#98A2B3" },
};
export const SECONDARY_BUTTON_SX = {
  ...BUTTON_BASE,
  color: NAVY,
  borderColor: "#C9D7E8",
  backgroundColor: "#fff",
  "&:hover": { borderColor: NAVY, backgroundColor: "#EEF3F9", boxShadow: "none" },
};
/** A tool button (IDV Calculator, View Premium Breakup): a navy tint, solid navy on hover (the owner picked it, 2026-10-27). */
export const TOOL_BUTTON_SX = {
  ...BUTTON_BASE,
  color: NAVY,
  border: "1px solid #B7C9E2",
  backgroundColor: "#E3ECF7",
  "&:hover": { borderColor: NAVY, backgroundColor: NAVY, color: "#fff", boxShadow: "none" },
};
/** A one-of-many switch (Company on the Online Policy form, Certificate for on the Brisk page): a grey track, the choice a white tile. */
export const CHOICE_TOGGLE_SX = {
  backgroundColor: "#F2F4F7",
  border: "1px solid #EAECF0",
  borderRadius: "10px",
  p: "4px",
  gap: "2px",
  // a phone has no room for four in a row: two by two inside the track
  display: { xs: "grid", sm: "inline-flex" },
  gridTemplateColumns: { xs: "1fr 1fr" },
  width: { xs: "100%", sm: "auto" },
  "& .MuiToggleButtonGroup-grouped": {
    margin: "0 !important",
    border: "0 !important",
    borderRadius: "7px !important",
  },
  "& .MuiToggleButton-root": {
    textTransform: "none",
    fontWeight: 600,
    fontFamily: FONT,
    fontSize: "13px",
    height: 32,
    px: 2,
    whiteSpace: "nowrap",
    color: "#475467",
    backgroundColor: "transparent",
    "&:hover": { backgroundColor: "#E9ECF1" },
  },
  "& .MuiToggleButton-root.Mui-selected": {
    backgroundColor: "#fff",
    color: NAVY,
    boxShadow: "0 1px 3px rgba(16, 24, 40, 0.12), 0 0 0 1px #E4E7EC",
    "&:hover": { backgroundColor: "#fff" },
  },
};
// the small labelled buttons of a list row (the View page's files and links)
export const ROW_BUTTON_SX = {
  ...TOOL_BUTTON_SX,
  height: 30,
  minWidth: 0,
  px: 1.25,
  fontSize: "12.5px",
  whiteSpace: "nowrap",
  "& .MuiButton-startIcon": { mr: 0.5, "& svg": { fontSize: 15 } },
};
export const DANGER_BUTTON_SX = {
  ...BUTTON_BASE,
  color: "#B42318",
  borderColor: "#FECDCA",
  backgroundColor: "#fff",
  "&:hover": { borderColor: "#B42318", backgroundColor: "#FEF3F2", boxShadow: "none" },
};

/** The step bar: navy for the step being filled and the ones done, Inter labels. */
export const STEPPER_SX = {
  "& .MuiStepLabel-label": { fontFamily: FONT, fontSize: "13px", fontWeight: 500, color: "#667085" },
  "& .MuiStepLabel-label.Mui-active": { color: NAVY, fontWeight: 700 },
  "& .MuiStepLabel-label.Mui-completed": { color: NAVY, fontWeight: 600 },
  "& .MuiStepIcon-root": { color: "#D0D5DD" },
  "& .MuiStepIcon-root.Mui-active": { color: NAVY },
  "& .MuiStepIcon-root.Mui-completed": { color: "#067647" },
  "& .MuiStepConnector-line": { borderColor: "#EAECF0" },
};

/** A card on the form (the preview's panel). */
export const CARD_SX = { borderRadius: "14px", border: "1px solid #EAECF0", backgroundColor: "#fff" };
